import { render, staticRenderFns } from "./StepsContact.vue?vue&type=template&id=6ab89740&"
import script from "./StepsContact.vue?vue&type=script&lang=js&"
export * from "./StepsContact.vue?vue&type=script&lang=js&"
import style0 from "./StepsContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StepsContact.vue"
export default component.exports